<template>
    <StylesheetEdit
        :schema="schema"
        :customer="customer"
        :modal-title="modalTitle"
        @submit="submit"
    >
        <template #default="{ open }">
            <button class="button button--icon button--big" @click.prevent="open">
                <IconPlus />
                <span v-t="'crm.stylesheet.create.trigger'" />
            </button>
        </template>
    </StylesheetEdit>
</template>

<script>
import StylesheetEdit from '../StylesheetEdit/StylesheetEdit';
import { IconPlus } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'StylesheetCreate',
    components: {
        StylesheetEdit,
        IconPlus,
    },
    props: {
        schema: {
            type: Object,
            default: () => ({}),
        },
        customer: {
            type: [Number, String],
            default: 0,
        },
        modalTitle: {
            type: String,
            default: 'crm.stylesheet.create.title',
        },
    },
    emits: ['submit'],
    methods: {
        submit(event) {
            this.$emit('submit', event);
        },
    },
};
</script>
